/* eslint-disable global-require */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// eslint-disable-next-line css-modules/no-unused-class
import s from './TurnosEspontaneos.css';
// const medicosClinicos = [
//     '../../../../public/images/ClinicaMedica/91252.jpg',
//     '../../../../public/images/ClinicaMedica/144731.jpg',
//     '../../../../public/images/ClinicaMedica/156280.jpg',
//     '../../../../public/images/ClinicaMedica/191577.jpg',
//     '../../../../public/images/ClinicaMedica/209560.jpg',
// ]

const doctors = {
  ClinicaMedica: [
    'ClinicaMedica/553',
    'ClinicaMedica/749',
    'ClinicaMedica/24579',
    'ClinicaMedica/19524',
    'ClinicaMedica/18046',
    'ClinicaMedica/17991',
  ],
  Pediatria: [
    'Pediatria/24576',
    'Pediatria/24577',
    'Pediatria/25829',
    'Pediatria/24574',
    'Pediatria/25241',
  ],
};

class TurnosEspontaneos extends React.Component {
  deleteWhiteSpaces = string => string.replace(/ /g, '');
  deleteAccents = string =>
    string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  render() {
    // const speciality = this.deleteWhiteSpaces(
    //   this.deleteAccents(this.props.especialidad),
    // );

    const images = doctors.ClinicaMedica.map((image, index) => (
      <li key={index.toString()}>
        <img
          key={image}
          // eslint-disable-next-line import/no-dynamic-require
          src={require(`../../../../public/images/${image}.jpg`)}
          alt=""
          className={`${s.imgAvatar}`}
        />
      </li>
    ));

    return (
      <div>
        <div className={` card ${s.content}`}>
          <div className={`card-header  text-center ${s.header}`}>
            Profesionales para Atención Inmediata
          </div>
          <div className="card-body">
            <div className="container">
              <div className="row">
                <div className={`col text-center ${s.divRow}`}>
                  {' '}
                  {/* ESTE ES EL CONTENEDOR DE LAS IMAGENES */}
                  <ul className={`${s.avataresUl}`}>{images}</ul>
                </div>
                <div className={`col ${s.buttonDiv}`}>
                  <button
                    onClick={this.props.press}
                    className={`btn ${s.button}`}
                    style={{ cursor: 'pointer' }}
                  >
                    Iniciar Atención
                  </button>
                  {/* <p className={`${s.turnwaitingTime} card-text ${s.wait}`}>
                    {this.props.turnWaitingTime &&
                      this.props.turnWaitingTime.aproxTime}
                    </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  espontaneo: state.telemedicina.espontaneo,
  // turnWaitingTime: state.telemedicina.turnWaitingTime,
});

TurnosEspontaneos.propTypes = {
  press: PropTypes.func.isRequired,
  // especialidad: PropTypes.string.isRequired,
  // turnWaitingTime: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(mapStateToProps, null)(withStyles(s)(TurnosEspontaneos));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/TurnosEspontaneos/TurnosEspontaneos.js